import { Language , Map } from "typings";
import produce from "immer";
import { TranslationActions } from "./action";

export interface State
{
    byId: Map<Map<string>>;
    languages: Language[];
    allAvailableLanguages: Language[];
    fieldTranslations:  Map<Map<Map<string>>>;
}

const initialState: State = {
    
    byId: {},
    languages: [],
    allAvailableLanguages: [],
    fieldTranslations: {}
};

export const reducer = (state = initialState, action: TranslationActions): State => produce(state, draft =>
{
    if (action.type === "LOAD_LANGUAGES")
    {
        draft.languages = action.languages;
    }

    if (action.type === "LOAD_TRANSLATION")
    {
        draft.byId[action.language] = action.translations;
    }
    
    if (action.type === "LOAD_FIELD_TRANSLATION")
    {
        draft.fieldTranslations[action.language] = action.translations;
    }

    if (action.type === "LOAD_LANGUAGES")
    {
        draft.languages = action.languages;
    }

    if (action.type === "NEW_FIELD")
    {
        Object.keys(draft.byId).forEach(lang =>
        {
            draft.byId[lang][action.fieldName] = "";
        });
    }

    if (action.type === "REMOVE_FIELD")
    {
        Object.keys(draft.byId).forEach(lang =>
        {
            delete draft.byId[lang][action.fieldName];
        });
    }

    if (action.type === "UPDATE_FIELD")
    {
        const { language, fieldName, value } = action;
        draft.byId[language][fieldName] = value;
    }
    if (action.type === "LOAD_ALL_AVAILABLE_LANGUAGES")
    {
        draft.allAvailableLanguages = action.languages;
    }


});


export const getLanguages = (state: State): Language[] =>
{
    return state.languages;
};


export const getAllAvailableLanguages = (state: State): Language[] =>
{
    return state.allAvailableLanguages;
};

export const getTranslations = (state: State, language: string) => state.byId[language];

export const getAllFieldTranslations = (state: State, language: string) => state.fieldTranslations[language];


export default reducer;


// WEBPACK FOOTER //
// ./src/state/translation/index.ts